import { render } from "./AllDataTable.vue?vue&type=template&id=246835ad&scoped=true"
import script from "./AllDataTable.vue?vue&type=script&lang=ts"
export * from "./AllDataTable.vue?vue&type=script&lang=ts"

import "./AllDataTable.vue?vue&type=style&index=0&id=246835ad&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-246835ad"

export default script